import React, { useRef } from 'react'

// https://www.algolia.com/doc/api-reference/widgets/react/
import { algoliasearch } from 'algoliasearch'
import { InstantSearch } from 'react-instantsearch'

// https://www.gatsbyjs.com/docs/how-to/local-development/environment-variables/#accessing-environment-variables-in-the-browser
const algoliaClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID, 
    process.env.GATSBY_ALGOLIA_SEARCH_KEY,
)

// Debounce utility function
const debounce = (fn, delay) => {
    let timeoutId
    return (...args) => {
        return new Promise((resolve, reject) => {
            clearTimeout(timeoutId)
            timeoutId = setTimeout(() => {
                fn(...args).then(resolve).catch(reject)
            }, delay)
        })
    }
}

// https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/vue/
const createSearchClient = () => {
    const debouncedSearch = debounce((requests) => algoliaClient.search(requests), 300)
    
    return {
        ...algoliaClient,
        search(requests) {
            if (requests.every(({ params }) => !params.query)) {
                return Promise.resolve({
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                        hitsPerPage: 0,
                        exhaustiveNbHits: false,
                        query: '',
                        params: '',
                    })),
                })
            }
            return debouncedSearch(requests)
        }
    }
}

// https://www.algolia.com/doc/api-reference/widgets/instantsearch/react/#examples
export default function SearchProvider({ children }) {
    // Only create search client once, providing InstantSearch a stable client
    const searchClient = useRef(createSearchClient()).current

    return (
        <InstantSearch
            searchClient={searchClient}
            indexName={process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
                'Rane Products' :
                'Rane Products Staging'
            }
        >
            {children}
        </InstantSearch>
    )
}
